import { React } from '@digsup/core-ui';
import { Icon } from '@digsup/components-icon';
import { Image } from '@digsup/components-image';

import { FeaturesItem } from './FeaturesItem';
import propertyImg from './assets/property.png';
import property2xImg from './assets/property@2x.png';
import property3xImg from './assets/property@3x.png';
import propertyMobileImg from './assets/property-mobile.png';
import propertyMobile2xImg from './assets/property-mobile@2x.png';
import propertyMobile3xImg from './assets/property-mobile@3x.png';

export const FeatureProperty = () => (
  <FeaturesItem
    title="Property insights"
    description="See detailed info for properties on and off the market, including exclusive stats like projected availability, investment risk, and popularity, as well as transit options, flood risk, and more."
    icon={
      <Icon
        name="thumbs-up"
        size="xlarge"
        shape="round"
        fill="digsup-blue-light"
        shapeColor="digsup-blue"
      />
    }
    media={
      <div className="l-homepage-features__property-media">
        <div className="l-homepage-features__property-media-img">
          <Image
            src={propertyImg}
            srcset={`
              ${propertyMobileImg} 464w,
              ${propertyImg} 590w,
              ${propertyMobile2xImg} 928w,
              ${property2xImg} 1180w,
              ${propertyMobile3xImg} 1392w,
              ${property3xImg} 1770w
            `}
            sizes="(max-width: 999px) 464px, 590px"
            placeholderImage=""
            alt="Detailed info for properties"
          />
        </div>
      </div>
    }
  />
);
